/** need add <div id="recaptcha-container"></div> for recaptcha **/
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable, from as observableFrom, throwError } from 'rxjs';
import { tap, map, switchMap } from 'rxjs/operators';


import { BankSessionIdResponse } from '../users.interface';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { FirebaseError } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import auth = firebase.auth;
import User = firebase.User;

const RECAPTCHA_CONTAINER_ID = 'recaptcha-container';
export const FIREBASE_CONFIG = environment.fcm;

@Injectable({
  providedIn: 'root'
})
export class AuthFcmService {

  private recaptchaVerified?: auth.RecaptchaVerifier;
  private authConfirmationResult?: auth.ConfirmationResult;

  static isFirebaseError(error: HttpErrorResponse | FirebaseError): error is FirebaseError {
    return (error as FirebaseError).code !== undefined;
  }

  private static getFireBaseIdToken(userCredential: auth.UserCredential): Observable<string> {
    return observableFrom(
      userCredential.user.getIdToken()
    );
  }

  constructor(private afAuth: AngularFireAuth) {
    const app = firebase.initializeApp(FIREBASE_CONFIG);
    if (!environment.production) {
        initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider('6LcBipIrAAAAAKqjo25r_zfe7sK9deDoDlbpLUHK'),
            // Optional argument. If true, the SDK automatically refreshes App Check tokens as needed.
            // isTokenAutoRefreshEnabled: true
        });
    }
  }

  getLoginCode(phoneNumber: string): Observable<BankSessionIdResponse> {
    // console.log(auth);
    // auth().settings.appVerificationDisabledForTesting = true;
    this.resetReCaptcha();
    this.recaptchaVerified = new firebase.auth.RecaptchaVerifier(RECAPTCHA_CONTAINER_ID, {
      size: 'invisible',
      'callback': response => console.log(response),
      'error-callback': error => console.log(error)
    });
    console.log('RECAPTCHA', this.recaptchaVerified);
    return observableFrom(
      this.afAuth.signInWithPhoneNumber(phoneNumber, this.recaptchaVerified)
    ).pipe(
      tap(result => this.authConfirmationResult = result),
      map(result => {
        return { success: true, sessid: result.verificationId, authType: 'fire-base' };
      })
    );
  }

  verifyLoginCode(verificationCode: string): Observable<string> {
    return (!this.authConfirmationResult)
      ? throwError({ fbAuthError: 'Missing auth confirmation result' })
      : observableFrom(this.authConfirmationResult.confirm(verificationCode))
        .pipe(
          switchMap(userCredential => AuthFcmService.getFireBaseIdToken(userCredential)),
        );
  }

  getAuthState(): Observable<User> {
    return this.afAuth.authState;
  }

  logout(): void {
    this.resetReCaptcha();
    this.afAuth.signOut();
  }

  public resetReCaptcha() {
    if (this.recaptchaVerified) {
      this.recaptchaVerified.clear();
      document.getElementById('recaptcha-wrapper')
        .innerHTML = `<div id="${ RECAPTCHA_CONTAINER_ID }" style="display:none;"></div>`;
    }
  }

}
